import { render, staticRenderFns } from "./RedCrossCheckmarks.vue?vue&type=template&id=dfa3bd7e"
import script from "./RedCrossCheckmarks.vue?vue&type=script&lang=js"
export * from "./RedCrossCheckmarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports